'use client';
import React from 'react';

import { RenderBlocks } from '../../../../components/blocks/render-blocks';
import { IMeetingplacePageHomeMinifiedExtendedHomePageChina } from '../../../../lib/fragments/meetingPlacePageHome-minified';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface ChinaPageHomeProps {
  contentfulMeetingPlacePageHome: IMeetingplacePageHomeMinifiedExtendedHomePageChina;
}

const ChinaPageHome = ({ data, locale }: any) => {
  const homepage = data?.meetingPlacePageHome;

  const mainBannerList = homepage?.meetingPlace?.mainBannerList
    ? [homepage?.meetingPlace?.mainBannerList]
    : [];

  const cardList =
    homepage?.meetingPlace?.cardList?.cardsCollection?.items?.filter(Boolean)
      ? homepage.meetingPlace.cardList.cardsCollection?.items?.filter(Boolean)
      : [];

  return (
    <>
      {/* ✅ GTM PAGE VIEW */}
      <GtmPageView
        homepage={homepage}
        language={locale}
        pageTitle={homepage?.meetingPlace?.name}
        excludeBrowserTitleSuffix
      />
      <main className="grid grid-cols-12 gap-5">
        <div className="col-span-12 lg:col-span-6">
          <RenderBlocks
            blocks={mainBannerList}
            meetingPlaceName={homepage?.meetingPlace?.name}
            node_locale={homepage?.meetingPlace?.sys?.locale}
          />
        </div>
        <div className="col-span-12 px-6 lg:col-span-6 lg:mt-6 lg:px-0">
          <RenderBlocks blocks={cardList} isChinaPage masonry />
        </div>
      </main>
    </>
  );
};

export default ChinaPageHome;
